import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function SwiperSlider() {
  return (
    <Swiper 
        autoplay
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={0}
        slidesPerView={1}
    >
      <SwiperSlide>
          <img src="/home/01.webp" className="w-full h-full object-cover" alt="BarraTour" />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/02.webp" className="w-full h-full object-cover"  alt="BarraTour" loading='lazy' />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/03.webp" className="w-full h-full object-cover"  alt="BarraTour" loading='lazy'  />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/04.webp" className="w-full h-full object-cover"  alt="BarraTour" loading='lazy'  />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/05.webp" className="w-full h-full object-cover"  alt="BarraTour" loading='lazy'  />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/06.webp" className="w-full h-full object-cover"  alt="BarraTour" loading='lazy'  />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/07.webp" className="w-full h-full object-cover"  alt="BarraTour" loading='lazy'  />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/08.webp" className="w-full h-full object-cover"  alt="BarraTour" loading='lazy'  />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/09.webp" className="w-full h-full object-cover"  alt="BarraTour" />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/10.webp" className="w-full h-full object-cover"  alt="BarraTour" />
      </SwiperSlide>
      <SwiperSlide>
          <img src="/home/11.jpeg" className="w-full h-full object-cover"  alt="BarraTour" />
      </SwiperSlide>
    </Swiper>
  );
};